// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Details_componentWrapper__Im0IL","price":"Details_price__CZKhf","title":"Details_title__HWuwh","label":"Details_label__SadBr"};